/* VSS Search Core 2.5.0. Pure ranking; never filters Shopify result pages. */
(function(root, factory) {
  const core = factory();
  if (typeof module === "object" && module.exports) module.exports = core;
  else root.VSSSearchCore = core;
})(typeof globalThis !== "undefined" ? globalThis : this, () => {
  "use strict";
  const config = {
  "families": [
    {
      "key": "bags",
      "aliases": [
        "rope bag",
        "rope bags",
        "sail bag",
        "sail bags",
        "bag",
        "bags"
      ]
    },
    {
      "key": "lifelines",
      "aliases": [
        "lifeline",
        "lifelines"
      ]
    },
    {
      "key": "pfds",
      "aliases": [
        "life jacket",
        "life jackets",
        "lifejacket",
        "lifejackets",
        "lifevest",
        "lifevests",
        "pfd",
        "pfds",
        "buoyancy aid",
        "buoyancy aids"
      ]
    },
    {
      "key": "gloves",
      "aliases": [
        "glove",
        "gloves",
        "gloevs"
      ]
    },
    {
      "key": "footwear",
      "aliases": [
        "sailing boots",
        "sailing shoes",
        "boot",
        "boots",
        "shoe",
        "shoes",
        "footwear"
      ]
    },
    {
      "key": "wetsuits",
      "aliases": [
        "wetsuit",
        "wetsuits",
        "long john",
        "longjohn"
      ]
    },
    {
      "key": "drysuits",
      "aliases": [
        "drysuit",
        "drysuits",
        "dry suit",
        "dry suits"
      ]
    },
    {
      "key": "jackets",
      "aliases": [
        "jacket",
        "jackets",
        "smock",
        "smocks",
        "spray top",
        "spray tops",
        "aquafleece"
      ]
    },
    {
      "key": "headwear",
      "aliases": [
        "hat",
        "hats",
        "cap",
        "caps",
        "headwear",
        "beanie",
        "beanies"
      ]
    },
    {
      "key": "sunglasses",
      "aliases": [
        "sunglass",
        "sunglasses"
      ]
    },
    {
      "key": "watches",
      "aliases": [
        "watch",
        "watches"
      ]
    },
    {
      "key": "harnesses",
      "aliases": [
        "harness",
        "harnesses"
      ]
    },
    {
      "key": "tops",
      "aliases": [
        "rashguard",
        "rashguards",
        "rash guard",
        "rash guards",
        "base layer",
        "base layers"
      ]
    },
    {
      "key": "blocks",
      "aliases": [
        "block",
        "blocks",
        "pulley",
        "pulleys"
      ]
    },
    {
      "key": "winches",
      "aliases": [
        "winch",
        "winches"
      ]
    },
    {
      "key": "cleats",
      "aliases": [
        "cleat",
        "cleats"
      ]
    },
    {
      "key": "clutches",
      "aliases": [
        "clutch",
        "clutches",
        "rope clutch",
        "rope clutches"
      ]
    },
    {
      "key": "shackles",
      "aliases": [
        "shackle",
        "shackles"
      ]
    },
    {
      "key": "turnbuckles",
      "aliases": [
        "turnbuckle",
        "turnbuckles"
      ]
    },
    {
      "key": "tracks",
      "aliases": [
        "track",
        "tracks",
        "traveler",
        "travelers",
        "traveller",
        "travellers"
      ]
    },
    {
      "key": "furling",
      "aliases": [
        "furler",
        "furlers",
        "furling"
      ]
    },
    {
      "key": "rigging",
      "aliases": [
        "standing rigging",
        "rigging terminal",
        "rigging terminals",
        "wire terminal",
        "wire terminals",
        "rigging cable",
        "rigging wire"
      ]
    },
    {
      "key": "ropes",
      "aliases": [
        "rope",
        "ropes",
        "line",
        "lines",
        "halyard",
        "halyards",
        "sheet",
        "sheets",
        "dyneema"
      ]
    },
    {
      "key": "compasses",
      "aliases": [
        "compass",
        "compasses"
      ]
    },
    {
      "key": "wind",
      "aliases": [
        "wind indicator",
        "wind indicators",
        "wind instrument",
        "wind instruments",
        "anemometer",
        "anemometers"
      ]
    },
    {
      "key": "electronics",
      "aliases": [
        "gps",
        "instrument",
        "instruments",
        "electronics",
        "race computer"
      ]
    },
    {
      "key": "covers",
      "aliases": [
        "cover",
        "covers"
      ]
    },
    {
      "key": "dollies",
      "aliases": [
        "dolly",
        "dollies"
      ]
    },
    {
      "key": "sails",
      "aliases": [
        "sail",
        "sails"
      ]
    },
    {
      "key": "tillers",
      "aliases": [
        "tiller",
        "tillers",
        "tiller extension",
        "tiller extensions"
      ]
    },
    {
      "key": "rudders",
      "aliases": [
        "rudder",
        "rudders",
        "rudderblade",
        "rudderhead"
      ]
    },
    {
      "key": "anchors",
      "aliases": [
        "anchor",
        "anchors",
        "anchoring"
      ]
    },
    {
      "key": "pumps",
      "aliases": [
        "pump",
        "pumps"
      ]
    },
    {
      "key": "cleaners",
      "aliases": [
        "cleaner",
        "cleaners",
        "cleaning",
        "polish",
        "polishes"
      ]
    },
    {
      "key": "fasteners",
      "aliases": [
        "screw",
        "screws",
        "bolt",
        "bolts",
        "fastener",
        "fasteners",
        "pin",
        "pins"
      ]
    },
    {
      "key": "centerboards",
      "aliases": [
        "centerboard",
        "centerboards",
        "centreboard",
        "centreboards"
      ]
    },
    {
      "key": "bailers",
      "aliases": [
        "bailer",
        "bailers"
      ]
    }
  ],
  "brands": [
    {
      "key": "harken",
      "aliases": [
        "harken"
      ]
    },
    {
      "key": "ronstan",
      "aliases": [
        "ronstan"
      ]
    },
    {
      "key": "allen",
      "aliases": [
        "allen brothers",
        "allen"
      ]
    },
    {
      "key": "antal",
      "aliases": [
        "antal"
      ]
    },
    {
      "key": "selden",
      "aliases": [
        "selden"
      ]
    },
    {
      "key": "lewmar",
      "aliases": [
        "lewmar"
      ]
    },
    {
      "key": "nautos",
      "aliases": [
        "nautos"
      ]
    },
    {
      "key": "wichard",
      "aliases": [
        "wichard"
      ]
    },
    {
      "key": "spinlock",
      "aliases": [
        "spinlock"
      ]
    },
    {
      "key": "karver",
      "aliases": [
        "karver"
      ]
    },
    {
      "key": "nodus",
      "aliases": [
        "nodus factory",
        "nodus"
      ]
    },
    {
      "key": "sea-sure",
      "aliases": [
        "sea sure"
      ]
    },
    {
      "key": "tylaska",
      "aliases": [
        "tylaska"
      ]
    },
    {
      "key": "colligo",
      "aliases": [
        "colligo marine",
        "colligo"
      ]
    },
    {
      "key": "sparcraft",
      "aliases": [
        "sparcraft"
      ]
    },
    {
      "key": "gill",
      "aliases": [
        "gill sailing gear",
        "gill"
      ]
    },
    {
      "key": "zhik",
      "aliases": [
        "zhik sailing gear",
        "zhik"
      ]
    },
    {
      "key": "rooster",
      "aliases": [
        "rooster sailing",
        "rooster"
      ]
    },
    {
      "key": "vaikobi",
      "aliases": [
        "vaikobi"
      ]
    },
    {
      "key": "helly-hansen",
      "aliases": [
        "helly hansen"
      ]
    },
    {
      "key": "mustang",
      "aliases": [
        "mustang survival",
        "mustang"
      ]
    },
    {
      "key": "mti",
      "aliases": [
        "mti life jackets",
        "mti"
      ]
    },
    {
      "key": "magic-marine",
      "aliases": [
        "magic marine"
      ]
    },
    {
      "key": "marlow",
      "aliases": [
        "marlow ropes",
        "marlow"
      ]
    },
    {
      "key": "samson",
      "aliases": [
        "samson ropes",
        "samson"
      ]
    },
    {
      "key": "new-england",
      "aliases": [
        "new england ropes",
        "new england"
      ]
    },
    {
      "key": "alpha",
      "aliases": [
        "alpha ropes"
      ]
    },
    {
      "key": "liros",
      "aliases": [
        "liros"
      ]
    },
    {
      "key": "robline",
      "aliases": [
        "robline"
      ]
    },
    {
      "key": "yale",
      "aliases": [
        "yale cordage",
        "yale"
      ]
    },
    {
      "key": "cousin",
      "aliases": [
        "cousin"
      ]
    },
    {
      "key": "robship",
      "aliases": [
        "robship"
      ]
    },
    {
      "key": "hayn",
      "aliases": [
        "hayn marine",
        "hayn"
      ]
    },
    {
      "key": "sta-lok",
      "aliases": [
        "sta lok"
      ]
    },
    {
      "key": "johnson",
      "aliases": [
        "johnson marine"
      ]
    },
    {
      "key": "schaefer",
      "aliases": [
        "schaefer marine",
        "schaefer"
      ]
    },
    {
      "key": "andersen",
      "aliases": [
        "andersen"
      ]
    },
    {
      "key": "facnor",
      "aliases": [
        "facnor"
      ]
    },
    {
      "key": "profurl",
      "aliases": [
        "profurl"
      ]
    },
    {
      "key": "cdi",
      "aliases": [
        "cdi"
      ]
    },
    {
      "key": "forespar",
      "aliases": [
        "forespar"
      ]
    },
    {
      "key": "clamcleat",
      "aliases": [
        "clamcleat"
      ]
    },
    {
      "key": "optiparts",
      "aliases": [
        "optiparts"
      ]
    },
    {
      "key": "windesign",
      "aliases": [
        "windesign"
      ]
    },
    {
      "key": "garmin",
      "aliases": [
        "garmin"
      ]
    },
    {
      "key": "vakaros",
      "aliases": [
        "vakaros"
      ]
    },
    {
      "key": "velocitek",
      "aliases": [
        "velocitek"
      ]
    },
    {
      "key": "sailmon",
      "aliases": [
        "sailmon"
      ]
    },
    {
      "key": "novasail",
      "aliases": [
        "novasail"
      ]
    },
    {
      "key": "tacktick",
      "aliases": [
        "tacktick"
      ]
    },
    {
      "key": "calypso",
      "aliases": [
        "calypso"
      ]
    },
    {
      "key": "raymarine",
      "aliases": [
        "raymarine"
      ]
    },
    {
      "key": "standard-horizon",
      "aliases": [
        "standard horizon"
      ]
    },
    {
      "key": "blue-performance",
      "aliases": [
        "blue performance"
      ]
    },
    {
      "key": "dynamic",
      "aliases": [
        "dynamic dollies"
      ]
    }
  ]
};
  const normalizationCache = new Map();
  const norm = value => {
    const raw=String(value||'');
    if(normalizationCache.has(raw))return normalizationCache.get(raw);
    const result=raw.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase()
      .replace(/(\d)\s+(mm|cm|ft|in|m)\b/g, '$1$2').replace(/['’]/g, '').replace(/[^a-z0-9.]+/g, ' ').replace(/\s+/g, ' ').trim();
    if(raw.length<=2000) {
      if(normalizationCache.size>=1024)normalizationCache.delete(normalizationCache.keys().next().value);
      normalizationCache.set(raw,result);
    }
    return result;
  };
  const has = (text, phrase) => !!phrase && (` ${norm(text)} `).includes(` ${norm(phrase)} `);
  const identifier = value => String(value || '').trim().toLowerCase(); // Keep punctuation: HR-465 != HR465.
  const equivalent = [
    ['centerboard','centreboard'], ['traveler','traveller'], ['block','pulley'],
    ['dolly','trolley'], ['drysuit','dry suit'], ['wetsuit','wet suit'],
    ['rashguard','rash guard'], ['rudder blade','rudderblade'], ['rudder head','rudderhead'],
    ['tiller extension','tillerextension'], ['turnbuckle','rigging screw'],
    ['glove','gloev'], ['ratchet','rachet'], ['aluminum','aluminium'],
    ['life jacket','lifejacket','pfd','buoyancy aid'], ['becket','bkt'], ['long finger','full finger']
  ];
  const boats = [
    {key:'ilca',aliases:['ilca','laser']}, {key:'c420',aliases:['c420','club 420','club420']},
    {key:'optimist',aliases:['optimist','opti']}, {key:'sunfish',aliases:['sunfish','isca']},
    {key:'j70',aliases:['j 70','j70']}, {key:'melges15',aliases:['melges 15','melges15']},
    {key:'fj',aliases:['flying junior','fj']}
  ];
  // Component identities are deliberately narrower than navigation families.
  const components = [
    'rope bag','boom vang','cam cleat','snap shackle','bilge pump','traveler car','traveler track',
    'halyard lock','halyard shackle','halyard block','terminal',
    'rudder blade','rudder head','tiller extension','wind indicator','wind instrument',
    'rope clutch','life jacket','buoyancy aid','trapeze harness','safety harness',
    'rudder','centerboard','daggerboard','tiller','mast','boom','sail','halyard','mainsheet',
    'shroud','forestay','rope','block','sheave','winch','cleat','clutch','shackle',
    'traveler','track','bailer','pump','screw','bolt','pin','shoe','boot','jacket','smock',
    'wetsuit','drysuit','glove','compass','gps','furler','dolly','cover','bag','turnbuckle'
  ];
  const singulars = {shoes:'shoe',gloves:'glove',clutches:'clutch',winches:'winch',dollies:'dolly',pulleys:'pulley',watches:'watch',compasses:'compass',bodies:'body'};
  const tokens = text => norm(text).split(' ').filter(Boolean).map(t=>singulars[t] || (t.length>3 && /s$/.test(t) && !/(ss|us|is|gps)$/.test(t)?t.slice(0,-1):t));
  function canonical(text) {
    let value=tokens(String(text||'').replace(/\bw\s*\/\s*(?!o\b)/gi,'with ').replace(/\bw\s*\/\s*o\b/gi,'without ')).join(' ');
    for(const group of equivalent) for(const alias of group.slice(1)) value=(` ${value} `).split(` ${alias} `).join(` ${group[0]} `).trim();
    return value;
  }
  const stop = new Set('a an the for with and by of to in on sailing sailboat boat marine supply gear part parts please'.split(' '));
  const terms = text => canonical(text).split(' ').filter(x=>x&&!stop.has(x));
  const boatOf = text => boats.find(b=>b.aliases.some(a=>has(text,a))) || null;
  function familyOf(text,type='') {
    for(const source of [type,text]) {
      const match=config.families.flatMap(f=>f.aliases.filter(a=>has(source,a)).map(a=>({key:f.key,length:a.length})))
        .sort((a,b)=>b.length-a.length)[0];
      if(match)return match.key;
    }
    return '';
  }
  const componentOf = text => {
    const full=canonical(text),lead=full.split(/\b(?:with|for)\b/)[0].trim();
    return components.find(c=>has(lead,c))||components.find(c=>has(full,c))||'';
  };
  const brandOf = text => config.brands.find(b=>b.aliases.some(a=>has(text,a)))?.key || '';
  function ruleScore(r,text,family,brand='') {
    if(!r.enabled || (r.brand && r.brand!==brand))return 0;
    if(r.match==='family')return r.family===family&&family?10:0;
    let score=r.match==='family_phrase'&&r.family===family&&family?10:0;
    for(const line of String(r.keywords||'').split(/\r?\n/)) {
      const key=norm(line);if(!key)continue;
      const ok=r.match==='exact'?text===key:r.match==='words'?key.split(' ').every(w=>has(text,w)):has(text,key);
      if(ok)score=Math.max(score,(r.match==='exact'?2000:100)+key.length);
    }
    return score;
  }
  function parse(raw,rules=[]) {
    raw=String(raw||'').trim();
    const advanced=/(?:\b[a-z_]+(?:\.[a-z_]+)?:|\b(?:AND|OR|NOT)\b|["()])/.test(raw);
    let query=raw,priceMin=null,priceMax=null;
    if(!advanced)query=query.replace(/\bgloevs\b/gi,'gloves').replace(/\brachet\b/gi,'ratchet');
    // Price is a native facet, applied by Shopify before pagination, never by card hiding.
    if(!advanced) {
      let max=query.match(/\b(under|below|less than|up to|max(?:imum)?|no more than)\s*\$?\s*(\d+(?:\.\d{1,2})?)\b/i);
      let min=query.match(/\b(over|above|at least|min(?:imum)?)\s*\$?\s*(\d+(?:\.\d{1,2})?)\b/i);
      const dimensionAfter=m=>m&&/^\s*(?:mm|cm|meters?|metres?|ft|feet|inches?|kg|lbs?)\b/i.test(query.slice(m.index+m[0].length));
      if(dimensionAfter(max))max=null;
      if(dimensionAfter(min))min=null;
      if(max){priceMax=Math.max(0,Math.round(Number(max[2])*100)-(/^(under|below|less than)$/i.test(max[1])?1:0));query=query.replace(max[0],' ');}
      if(min){priceMin=Math.round(Number(min[2])*100)+(/^(over|above)$/i.test(min[1])?1:0);query=query.replace(min[0],' ');}
      query=query.trim().replace(/\s+/g,' ');
    }
    const original=norm(query), initialFamily=familyOf(original), brand=brandOf(original);
    const ranked=rules.map((r,index)=>({r,index,score:ruleScore(r,original,initialFamily,brand)}))
      .filter(x=>x.score).sort((a,b)=>b.score-a.score||a.index-b.index);
    const rule=ranked[0]?.r || null;
    // Only an explicit matched expression can rewrite retrieval, never family membership.
    if(!advanced && rule && rule.mode==='alias' && rule.target?.trim()) {
      const key=String(rule.keywords||'').split(/\r?\n/).map(norm).filter(k=>k&&has(original,k)).sort((a,b)=>b.length-a.length)[0];
      if(key) {
        // Whole expressions can change; mixed technical text keeps the original characters.
        if(original===key)query=rule.target.trim();
        else if(['phrase','family_phrase'].includes(rule.match)) {
          const words=key.split(' ').map(w=>w.replace(/[.*+?^${}()|[\]\\]/g,'\\$&'));
          const expression=new RegExp('(^|\\b)'+words.join('[\\s-]+')+'(?=\\b|$)','i');
          query=query.replace(expression,rule.target.trim());
        }
      }
    }
    const text=norm(query),family=familyOf(text);
    let identifierQuery=query;
    const brandEntry=config.brands.find(b=>b.key===brandOf(text));
    if(brandEntry) for(const alias of [...brandEntry.aliases].sort((a,b)=>b.length-a.length)) {
      if(norm(identifierQuery).startsWith(norm(alias)+' ')) {identifierQuery=identifierQuery.slice(alias.length).trim();break;}
    }
    // Only matched rules may contribute discovery. Empty family is never a fallback.
    const contextRule=ranked[0]?.r || null;
    const lineIntent=/\b(rope|line|cordage|halyard|mainsheet)\b/.test(canonical(query)) && !/\b(clutch|lock|shackle|block|bag|cleat|cutter|splicing kit)\b/.test(canonical(query));
    return {raw,query,canonical:query,text,family,brand:brandOf(text),boat:boatOf(text),component:componentOf(text),
      terms:terms(text),identifierQuery,priceMin,priceMax,advanced,changed:query!==raw,rule,contextRule,lineIntent,
      clarify:!advanced && rule?.mode==='clarify',
      code:!advanced && /^(?=.{3,64}$)(?=.*\d)[a-zA-Z0-9][a-zA-Z0-9. /_-]*$/.test(identifierQuery) && !/\s/.test(identifierQuery.replace(/^[a-z]{1,3}\s+(?=\d)/i,'')) && !boatOf(identifierQuery) && !/^\d+(?:\.\d+)?\s*(?:mm|cm|m|ft|in|kg|lb)$/i.test(identifierQuery)};
  }
  function url(intent,base,origin,type='') {
    const u=new URL(base,origin);
    u.search='';u.searchParams.set('q',intent.query);u.searchParams.set('options[prefix]','last');
    if(intent.changed)u.searchParams.set('vss_query',intent.raw);
    if(intent.priceMin!==null)u.searchParams.set('filter.v.price.gte',(intent.priceMin/100).toFixed(2));
    if(intent.priceMax!==null)u.searchParams.set('filter.v.price.lte',(intent.priceMax/100).toFixed(2));
    if(intent.priceMin!==null||intent.priceMax!==null)u.searchParams.set('type','product');
    if(type){u.searchParams.set('type','product');u.searchParams.set('filter.p.product_type',type);}
    return u;
  }
  const quote = text => '"'+String(text).replace(/\\/g,'\\\\').replace(/"/g,'\\"')+'"';
  const compactIdentifier = value => identifier(value).replace(/[\s._/\-]+/g,'');
  const exactQuery = raw => {
    const values=[...new Set([String(raw||'').trim(),compactIdentifier(raw)])].filter(Boolean);
    return '('+values.flatMap(v=>['variants.sku:'+quote(v),'variants.barcode:'+quote(v)]).join(' OR ')+')';
  };
  const factCache = new WeakMap(); // Product objects are immutable for the lifetime of a response.
  function facts(p) {
    if(factCache.has(p))return factCache.get(p);
    const title=canonical(p.title),type=canonical(p.type),vendor=canonical(p.vendor);
    const tags=canonical((p.tags||[]).join(' '));
    const collections=canonical((p.collections||[]).map(c=>typeof c==='string'?c:c.title).join(' '));
    const technical=p.technical||{};
    const detail=canonical([p.variantTitle,technical.blockConfiguration,technical.partCategory,technical.materialFinish,technical.configuration,technical.sheaveType].filter(Boolean).join(' '));
    const value={title,type,vendor,tags,collections,detail,body:canonical(p.body),family:familyOf(p.title,p.type),brand:brandOf(p.vendor)};
    factCache.set(p,value);return value;
  }
  // A line may include a spliced fitting; a lock mentioning rope is still hardware.
  const hardwareLine = text => /\b(lock|shackle|block|clutch|cleat|restrainer|exit plate|bag|cutter)\b/.test(canonical(text));
  function isLine(p) {
    const type=canonical(p.type),title=canonical(p.title);
    if(/^(rope|line|cordage)$/.test(type)||/\b(halyard|control|mooring|dock) line\b/.test(type))return true;
    return /\b(rope|line|halyard assembly)\b/.test(title)&&!hardwareLine(title);
  }
  // Exact equality keeps punctuation and leading zeroes. A normalized or partial
  // code is useful retrieval evidence, but is NEVER labelled an exact identifier.
  function identifierMatch(p,i) {
    if(i.advanced)return {level:0,exact:false};
    const q=identifier(i.identifierQuery),compact=compactIdentifier(q);
    const values=[p.sku,p.mpn,p.barcode,...(p.variants||[]).flatMap(v=>[v.sku,v.mpn,v.barcode])].filter(Boolean).map(identifier);
    const publishedMatch=identifier(p.matchQuery)===q;
    if(values.includes(q)||(publishedMatch&&p.matchKind==='exact'))return {level:3,exact:true};
    if(!i.code)return {level:0,exact:false};
    if(compact.length>=4&&values.some(v=>compactIdentifier(v)===compact)||publishedMatch&&p.matchKind==='normalized')return {level:2,exact:false};
    if(values.some(v=>strongPartial(v,q))||publishedMatch&&p.matchKind==='partial')return {level:1,exact:false};
    return {level:0,exact:false};
  }
  function strongPartial(value,query) {
    const v=identifier(value),q=identifier(query);
    if(q.length<4||!/[0-9]/.test(q)||q===v||!v.includes(q))return false;
    // Do not treat 2637 as a strong match for 12637. Alphanumeric fragments
    // such as EX1217 may legitimately have a vendor prefix in the stored SKU.
    if(/^\d+$/.test(q)) {
      const at=v.indexOf(q),before=v[at-1]||'',after=v[at+q.length]||'';
      if(/\d/.test(before)||/\d/.test(after))return false;
    }
    return q.length/v.length>=0.35;
  }
  const featureGroups=[
    ['short finger','long finger','full finger'],['single','double','triple'],
    ['black','white','red','blue','yellow','orange','green','pink','grey','gray'],
    ['carbon','aluminum','stainless steel','polyester','nylon','dyneema']
  ];
  const featureTerms=['becket','swivel','ratchet','inflatable',...featureGroups.flat()];
  const dimensions=text=>[...canonical(text).matchAll(/\b(\d+(?:\.\d+)?)(mm|cm|ft|in|m)\b/g)].map(m=>m[0]);
  const negative=(text,word)=>['no ','without ','non ','w o '].some(prefix=>has(text,prefix+word));
  function requestedFeatures(i) {
    return featureTerms.filter(x=>has(canonical(i.query),x)).map(value=>({value,negative:negative(canonical(i.query),value)}));
  }
  function dimensionEvidence(p,i) {
    const f=facts(p),t=p.technical||{};
    let specific='';
    if(i.family==='blocks'&&t.sheaveSize)specific=String(t.sheaveSize);
    if((i.lineIntent||i.family==='ropes')&&t.ropeDiameterMm!==undefined&&t.ropeDiameterMm!==null&&t.ropeDiameterMm!=='')specific=String(t.ropeDiameterMm)+'mm';
    // A structured sheave size has a known role. Other dimensions in a block
    // description may instead be maximum line diameter or overall length.
    if(specific&&/^\d+(?:\.\d+)?$/.test(specific))specific+='mm';
    return dimensions(specific||[p.variantTitle,f.title].filter(Boolean).join(' '));
  }
  function constraintEvidence(p,i) {
    const f=facts(p),text=[f.title,f.type,f.detail].join(' '),conflicts=[];
    const wantedDimensions=dimensions(i.query),available=dimensionEvidence(p,i);
    const rangeText=i.family==='blocks'?String(p.technical?.sheaveSize||''):[p.title,p.variantTitle].filter(Boolean).join(' ');
    const ranges=[...rangeText.toLowerCase().matchAll(/(\d+(?:\.\d+)?)\s*(?:mm|cm|ft|in|m)?\s*[-\u2013\u2014]\s*(\d+(?:\.\d+)?)\s*(mm|cm|ft|in|m)\b/g)];
    let matched=0,requested=wantedDimensions.length;
    for(const d of wantedDimensions) {
      if(available.includes(d)||ranges.some(r=>d.replace(/[0-9.]/g,'')===r[3]&&parseFloat(d)>=Number(r[1])&&parseFloat(d)<=Number(r[2])))matched++;
      else if(available.some(x=>x.replace(/[0-9.]/g,'')===d.replace(/[0-9.]/g,'')))conflicts.push('dimension:'+d);
    }
    for(const feature of requestedFeatures(i)) {
      requested++;
      const present=has(text,feature.value),negated=negative(text,feature.value);
      if(present&&negated===feature.negative)matched++;
      else if(present)conflicts.push('feature:'+feature.value);
      else if(!feature.negative) {
        const group=featureGroups.find(g=>g.includes(feature.value));
        if(group?.some(x=>x!==feature.value&&has(text,x)&&!negative(text,x)))conflicts.push('feature:'+feature.value);
        else if(has(f.body,feature.value)) { if(negative(f.body,feature.value))conflicts.push('feature:'+feature.value);else matched++; }
      }
    }
    if(i.brand&&f.brand&&f.brand!==i.brand)conflicts.push('brand');
    if(i.boat) {
      const title=f.title.startsWith(f.vendor+' ')?f.title.slice(f.vendor.length+1):f.title;
      if(!i.boat.aliases.some(a=>has(title,a))&&boats.some(b=>b.key!==i.boat.key&&b.aliases.some(a=>has(title,a))))conflicts.push('boat-label');
    }
    return {matched,requested,conflicts};
  }
  function accessoryFor(p,i) {
    const f=facts(p),q=canonical(i.query);
    const accessories=['cover','bag','case','mount','mounting','bracket','cradle','lid','cable','carrier','liner','clip','shim','step','casting','base','adapter','belt extender','bungy','bungee','retainer','insert','repair kit','replacement wheel','strap','gasket','screw','bolt','pin','gudgeon','pintle','joint'];
    if(accessories.some(x=>has(q,x)))return false;
    if(accessories.some(x=>has(f.title.split(/\bwith\b/)[0],x)))return true;
    if(/\b(accessory|accessorie)\b/.test(f.type))return true;
    return ['rudder','mast'].includes(i.component)&&has(f.title,'head')&&!has(q,'head');
  }
  function score(p,i) {
    const f=facts(p),id=identifierMatch(p,i),exact=id.exact;
    if(i.advanced)return {tier:exact?9:0,points:0,exact};
    const b=i.boat,boatMatch=b&&b.aliases.some(a=>has(f.title+' '+f.tags+' '+f.collections,a));
    const explicitBoat=b&&b.aliases.some(a=>has(f.title,a));
    const literal=terms(i.query),strongText=[f.title,f.type,f.vendor,f.detail].join(' ');
    const accessory=accessoryFor(p,i),constraints=constraintEvidence(p,i);
    const all=literal.length>0&&literal.every(t=>has(strongText,t)||has(f.body,t));
    const titleExact=canonical(i.query)===f.title;
    const component=i.component,componentMatch=component&&componentAliases(component).some(c=>has(f.title+' '+f.type,canonical(c)));
    const familyMatch=i.family&&f.family===i.family;
    // A model is a constrained title identity, not a replacement/accessory or
    // the mere presence of a manufacturer's name somewhere in a description.
    const brandWords=(config.brands.find(x=>x.key===i.brand)?.aliases||[]).flatMap(terms);
    const modelWords=literal.filter(x=>!brandWords.includes(x));
    const modelMatch=!i.code&&!i.component&&!i.family&&!i.boat&&modelWords.length>0&&modelWords.some(t=>t.length>=3)&&modelWords.every(t=>has(f.title,t))&&(!i.brand||f.brand===i.brand)&&!accessory;
    let tier=0;
    if(exact)tier=9;
    else if(id.level===2)tier=8;
    else if(modelMatch)tier=7;
    else if(id.level===1)tier=6;
    else if(titleExact&&!accessory)tier=5;
    else if(all&&!accessory)tier=5;
    else if((componentMatch||familyMatch||boatMatch)&&!accessory)tier=4;
    else if(componentMatch||familyMatch||boatMatch)tier=3;
    else if(literal.some(t=>has(strongText+' '+f.tags,t)))tier=2;
    else if(literal.some(t=>has(f.body,t)))tier=1;
    if(i.lineIntent&&!id.level)tier=isLine(p)?Math.max(tier,4):Math.min(tier,2);
    // Unknown is not a contradiction. Explicitly conflicting sizes/brands or
    // features cannot beat otherwise pertinent candidates through keyword count.
    if(i.family&&f.family&&i.family!==f.family&&!id.level)tier=Math.min(tier,3);
    if(constraints.conflicts.length&&!id.level)tier=Math.min(tier,2);
    let points=0;
    for(const t of literal)points+=has(f.title,t)?20:has(f.detail,t)?18:has(f.type,t)?12:has(f.vendor,t)?10:has(f.tags,t)?4:has(f.body,t)?2:0;
    if(boatMatch)points+=25;if(explicitBoat)points+=20;
    if(componentMatch)points+=40;if(familyMatch)points+=15;
    if(i.brand&&f.brand===i.brand)points+=40;
    if(component&&componentOf(p.title)===component)points+=15;
    if(accessory)points-=60;
    points+=constraints.matched*35-constraints.conflicts.length*150;
    if(i.lineIntent&&isLine(p))points+=/^(rope|line|cordage)$|halyard line/.test(f.type)?100:50;
    return {tier,points,exact,identifierLevel:id.level,accessory,conflicts:constraints.conflicts,attributeMatches:constraints.matched};
  }
  const compareScores=(a,b)=>b.tier-a.tier||b.points-a.points;
  function rank(products,intent) {
    return products.map((product,index)=>({product,index,...score(product,intent)}))
      .sort((a,b)=>compareScores(a,b)||a.index-b.index);
  }
  function collectionScore(c,i) {
    if(i.code||i.advanced)return 0;
    const text=canonical(c.title+' '+(c.handle||'')),b=boatOf(text),brand=brandOf(text);
    if(i.boat&&b&&b.key!==i.boat.key||i.brand&&brand&&brand!==i.brand)return 0;
    const component=i.component&&componentAliases(i.component).some(a=>has(text,canonical(a)));
    const child=i.component&&(relatedComponents[i.component]||[]).some(a=>has(text,a));
    const family=i.family&&familyOf(text)===i.family;
    // A shared brand is insufficient for Harken cam cleat -> Harken Winches.
    if(i.component&&!component&&!child&&!family)return 0;
    if(!i.component&&i.family&&!family)return 0;
    if(!i.component&&!i.family&&i.boat&&b?.key!==i.boat.key)return 0;
    if(!i.component&&!i.family&&!i.boat&&i.brand&&brand!==i.brand)return 0;
    const evidence=constraintEvidence({title:c.title,type:'',vendor:'',technical:{}},i);
    if(evidence.conflicts.length)return 0;
    if(i.lineIntent&&hardwareLine(text))return 0;
    let points=terms(i.query).reduce((n,t)=>n+(has(text,t)?10:0),0);
    if(component)points+=80;else if(child)points+=30;
    if(family)points+=20;
    if(i.boat&&b?.key===i.boat.key)points+=100;
    if(i.brand&&brand===i.brand)points+=50;
    // The umbrella collection leads an unbranded family query.
    if(!i.brand&&!brand&&labelKey(c.title)===labelKey(i.query))points+=100;
    points+=evidence.matched*25;
    return points;
  }
  function collections(items,i,origin) {
    const seen=new Set();
    return items.filter(c=>{
      try {const u=new URL(c.url,origin);if(u.origin!==origin||!u.pathname.includes('/collections/')||seen.has(u.pathname)||c.count===0)return false;seen.add(u.pathname);return true;}catch{return false;}
    }).map((c,index)=>({...c,index,score:collectionScore(c,i)})).filter(c=>c.score>0)
      .sort((a,b)=>b.score-a.score||a.index-b.index).slice(0,8);
  }
  // Navigation relationships are not retrieval synonyms. Only catalog-backed children are offered.
  const relatedComponents = {rudder:['rudder blade','rudder head','tiller','pintle','gudgeon'],mast:['mast','spreader'],halyard:['halyard']};
  const unsafeLabel = /\b(certified|certification|approved|class legal|uscg|iso\s*\d|ce approved)\b/i;
  const genericType = /^(our brands|products?|accessories|sailing accessories|sale|uncategorized)$/i;
  // Small attribute vocabulary, not a list of queries or products. Each value needs catalog evidence.
  const attributes = [
    {key:'short-finger',label:'Short-finger',aliases:['short finger','short-finger'],family:'gloves'},
    {key:'long-finger',label:'Long-finger',aliases:['long finger','long-finger','full finger','full-finger'],family:'gloves'},
    {key:'cold-weather',label:'Cold-weather',aliases:['cold weather','cold-weather'],family:'gloves'},
    {key:'complete',label:'Complete',aliases:['complete']},
    {key:'unrigged',label:'Unrigged',aliases:['unrigged'],component:'mast'},
    {key:'hooded',label:'Hooded',aliases:['hooded'],family:'jackets'},
    {key:'inflatable',label:'Inflatable',aliases:['inflatable'],family:'pfds'},
    {key:'junior',label:'Junior',aliases:['junior'],family:'gloves'},
    {key:'carbon',label:'Carbon',aliases:['carbon']},
    {key:'aluminum',label:'Aluminum',aliases:['aluminum','aluminium']},
    {key:'dyneema',label:'Dyneema',aliases:['dyneema'],family:'ropes'}
  ];
  const fieldValue = (p,field) => field==='product_type'?p.type:field==='tag'?(p.tags||[]).join(' '):field==='variants.title'?p.variantTitle||'':p[field]||'';
  const leaf = (field,value) => ({field,value});
  const any = clauses => ({any:clauses});
  const clauseMatches = (p,c) => c.any?c.any.some(x=>clauseMatches(p,x)):['product_type','vendor'].includes(c.field)?norm(fieldValue(p,c.field))===norm(c.value):has(canonical(fieldValue(p,c.field)),canonical(c.value));
  const clauseQuery = c => c.any?'('+c.any.map(clauseQuery).join(' OR ')+')':c.field+':'+quote(c.value);
  const phraseFields = (phrases,fields=['title','product_type','tag']) => any(phrases.flatMap(value=>fields.map(field=>leaf(field,value))));
  function componentAliases(component) {
    if(component==='life jacket'||component==='buoyancy aid')return ['life jacket','lifejacket','pfd','buoyancy aid'];
    return equivalent.find(g=>g.includes(component))||[component];
  }
  function discoveryScope(i,products) {
    const scope=[];
    // Category tags can span several boats. A class-labelled destination needs an explicit title.
    if(i.boat)scope.push(phraseFields(has(i.text,'laser')?['laser']:i.boat.aliases,['title']));
    if(i.brand) {
      const vendors=[...new Set(products.filter(p=>brandOf(p.vendor)===i.brand).map(p=>p.vendor))];
      if(vendors.length)scope.push(any(vendors.map(v=>leaf('vendor',v))));
    }
    const ignored=new Set([
      ...(i.boat?i.boat.aliases.flatMap(terms):[]),
      ...componentAliases(i.component).flatMap(terms),
      ...(config.brands.find(b=>b.key===i.brand)?.aliases||[]).flatMap(terms),
      ...(config.families.find(f=>f.key===i.family)?.aliases||[]).flatMap(terms)
    ]);
    // Keep model, size and technical qualifiers. Prefixes only reflect actual returned text.
    for(const term of terms(i.query).filter(t=>!ignored.has(t))) {
      const c=phraseFields([term],['title','product_type','tag','variants.title','body']);
      if(products.some(p=>clauseMatches(p,c)))scope.push(c);
      else if(/^[a-z0-9]{3,}$/.test(term)) {
        const completions=[...new Set(products.flatMap(p=>tokens(p.title+' '+p.type)).filter(word=>word.startsWith(term)))].slice(0,10);
        scope.push(completions.length?phraseFields(completions,['title','product_type']):c);
      }
      else scope.push(c);
    }
    return scope;
  }
  function relevantProduct(p,i,related=false) {
    const f=facts(p);
    if(constraintEvidence(p,i).conflicts.length||(!related&&accessoryFor(p,i)))return false;
    if(i.lineIntent&&!isLine(p))return false;
    if(i.boat&&!i.boat.aliases.some(a=>has(f.title+' '+f.tags,a)))return false;
    // A maker's name at the start of a title is not evidence for a different boat class.
    if(i.boat) {
      const other=boats.some(b=>b.key!==i.boat.key&&b.aliases.some(a=>has(f.title,a)));
      const withoutVendor=f.title.startsWith(f.vendor+' ')?f.title.slice(f.vendor.length).trim():f.title;
      if(other&&!i.boat.aliases.some(a=>has(withoutVendor,a)))return false;
    }
    if(i.brand&&f.brand!==i.brand)return false;
    if(i.component) {
      const match=componentAliases(i.component).some(a=>has(f.title+' '+f.type+(i.component==='halyard'&&isLine(p)?' '+f.tags:''),canonical(a)));
      const relation=related&&(relatedComponents[i.component]||[]).some(c=>has(f.title+' '+f.type,c));
      if(!match&&!relation)return false;
    } else if(i.family&&f.family!==i.family)return false;
    else if(!i.boat&&!i.brand&&!i.family&&!terms(i.query).some(t=>tokens(f.title+' '+f.type).some(word=>word.startsWith(t))))return false;
    return true;
  }
  const labelKey = label => {
    let value=canonical(label).replace(/\bgloev\b/g,'glove');
    for(const b of boats)for(const alias of b.aliases)value=(' '+value+' ').split(' '+alias+' ').join(' '+b.key+' ').trim();
    if(has(value,'halyard'))value=value.replace(/\brope\b/g,'');
    return [...new Set(terms(value))].sort().join(' ');
  };
  function suggestions(i,products,native=[],rules=[],catalog=[],options={}) {
    if(i.code||i.advanced)return [];
    const origin=options.origin||'https://vss.invalid',base=options.base||'/search';
    const scope=discoveryScope(i,products),rows=products.filter(p=>relevantProduct(p,i)),relatedRows=products.filter(p=>relevantProduct(p,i,true));
    const candidates=[],subject=i.lineIntent?(i.component==='halyard'?'halyard rope':'rope'):({gloves:'sailing gloves',pfds:'sailing PFDs'}[i.family])||i.component||'';
    const boatLabel=i.boat?(i.boat.key==='ilca'?'Laser / ILCA':i.boat.key==='c420'?'C420':i.boat.aliases[0]):'';
    const titleCase=s=>s?(String(s).charAt(0).toUpperCase()+String(s).slice(1)).replace(/\bilca\b/gi,'ILCA').replace(/\bc420\b/gi,'C420').replace(/\bcfj\b/gi,'CFJ').replace(/\bwindesign\b/gi,'WinDesign').replace(/\bcdi\b/gi,'CDI'):'';
    function addSearch(label,clauses,pool,kind,weight,group='search') {
      // The label must not silently discard the brand, measure, or model that
      // the destination query preserves. Only presentation is de-duplicated.
      const ignored=new Set([...(i.boat?i.boat.aliases.flatMap(terms):[]),...componentAliases(i.component).flatMap(terms),...(config.families.find(f=>f.key===i.family)?.aliases||[]).flatMap(terms)]);
      const missing=terms(i.query).filter(t=>!ignored.has(t)&&!has(canonical(label),t));
      if(missing.length)label=[...new Set(missing),label].join(' ');
      const evidence=pool.filter(p=>clauses.every(c=>clauseMatches(p,c)));
      if(!evidence.length||!label||unsafeLabel.test(label))return;
      const query=clauses.map(clauseQuery).join(' AND '),u=new URL(base,origin);
      u.search='';u.searchParams.set('q',query);u.searchParams.set('type','product');u.searchParams.set('options[prefix]','none');u.searchParams.set('vss_query',label);
      if(i.priceMin!==null)u.searchParams.set('filter.v.price.gte',(i.priceMin/100).toFixed(2));
      if(i.priceMax!==null)u.searchParams.set('filter.v.price.lte',(i.priceMax/100).toFixed(2));
      if(options.type)u.searchParams.set('filter.p.product_type',options.type);
      candidates.push({label:titleCase(label),query,url:u.href,group,kind,score:weight+Math.min(evidence.length,5),evidence:evidence.map(p=>p.handle),clauses});
    }
    function typeScope(type,pool=rows) {
      const clauses=[leaf('product_type',type),...scope];
      // Preserve the requested component if the catalog type is broader (e.g. Rudder Hardware).
      if(i.component&&(/[&/]|\band\b/i.test(type)||!componentAliases(i.component).some(c=>canonical(type)===canonical(c)))) {
        const c=phraseFields(componentAliases(i.component),i.lineIntent?['title','tag','body']:['title']);
        if(pool.some(p=>clauseMatches(p,c)))clauses.push(c);
      }
      if(i.lineIntent&&!/^(rope|line|cordage)$|halyard line/.test(canonical(type)))clauses.push(phraseFields(['rope','line','halyard assembly'],['title']));
      return clauses;
    }
    const types=[...new Set(relatedRows.map(p=>p.type).filter(t=>t&&!genericType.test(t)&&!unsafeLabel.test(t)))];
    if(products.some(p=>canonical(p.title)===canonical(i.query))&&types.length<2)return [];
    for(const type of types) {
      if(i.lineIntent&&!/^(rope|line|cordage)$|halyard line/.test(canonical(type)))continue;
      const otherComponent=componentOf(type);
      if(i.component&&otherComponent&&!has(canonical(type),i.component)&&!(relatedComponents[i.component]||[]).includes(otherComponent))continue;
      const same=relatedRows.filter(p=>p.type===type),specific=rows.some(p=>p.type===type);
      const clauses=specific?typeScope(type):[leaf('product_type',type),...scope];
      const detail=i.lineIntent?subject:i.component?.includes(' ')&&!has(canonical(type),i.component)?i.component:type;
      const label=[boatOf(type)?.key===i.boat?.key?'':boatLabel,detail].filter(Boolean).join(' ');
      if(labelKey(label)!==labelKey(i.query)&&!(types.length===1&&!i.boat&&i.family))addSearch(label,clauses,same,'type',has(canonical(type),i.component)?79:specific?73:77,'refine');
    }
    for(const a of attributes) {
      if(!subject)continue;
      if(a.family&&a.family!==i.family||a.component&&a.component!==i.component||a.aliases.some(x=>has(canonical(i.query),canonical(x))))continue;
      const eligible=rows.filter(p=>a.aliases.some(x=>has(canonical(p.title),canonical(x))));
      for(const type of [...new Set(eligible.map(p=>p.type).filter(t=>t&&!genericType.test(t)))]) {
        addSearch([a.label,boatLabel,subject||type].filter(Boolean).join(' '),[...typeScope(type),phraseFields(a.aliases,['title'])],eligible,'attribute:'+a.key,90);
      }
    }
    // Applications come from actual product tags; internal tags and certification claims are never exposed.
    const applications=[...new Set(rows.flatMap(p=>p.tags||[]))].filter(t=>/^(main|jib|spinnaker|genoa) halyard$/i.test(t));
    if(i.lineIntent||i.component==='halyard')for(const tag of applications) {
      const pool=rows.filter(p=>(p.tags||[]).includes(tag));
      const types=[...new Set(pool.map(p=>p.type).filter(Boolean))];
      if(types.length)addSearch(tag+' rope',[...scope,leaf('tag',tag),any(types.map(t=>leaf('product_type',t)))],pool,'application',95);
    }
    // Merchant refinements remain useful only when their exact terms are witnessed in the right products.
    for(const c of i.contextRule?.choices||[]) {
      if(!c.label||!c.query||i.clarify||has(canonical(i.query),canonical(c.query)))continue;
      const wanted=terms(c.query);if(!wanted.length||i.lineIntent&&applications.some(a=>wanted.some(t=>has(a,t))))continue;
      for(const type of [...new Set(rows.map(p=>p.type).filter(t=>t&&!genericType.test(t)))]) {
        addSearch([boatLabel,c.label].filter(Boolean).join(' '),[...typeScope(type),...wanted.map(t=>phraseFields([t],['title']))],rows,'merchant',75);
      }
    }
    // Native query suggestions are candidates, not proof. Reject fragments and require one product to support every term.
    for(const c of native) {
      const text=String(c.text||'').trim(),next=parse(text,rules),tt=terms(text);
      if(!text||tt.length<2||tt.length>7||/\b(w|wo|with|for)\s*$/i.test(text)||/\b(w|wo)\b/i.test(text)||labelKey(text)===labelKey(i.query))continue;
      if(i.boat&&(next.boat?.key!==i.boat.key||boats.some(b=>b.key!==i.boat.key&&b.aliases.some(a=>has(text,a))))||i.component&&!componentAliases(i.component).some(a=>has(canonical(text),canonical(a)))||i.lineIntent&&hardwareLine(text))continue;
      const extra=tt.filter(t=>!terms(i.query).includes(t));
      if(!extra.length||!next.component&&!next.family&&!i.component)continue;
      const pool=rows.filter(p=>tt.every(t=>has(canonical(p.title+' '+p.type+' '+p.vendor),t)));
      for(const type of [...new Set(pool.map(p=>p.type).filter(t=>t&&!genericType.test(t)))])addSearch(text,[...typeScope(type),...extra.map(t=>phraseFields([t],['title','vendor']))],pool,'native',85);
    }
    // Brands use the exact vendor and product type returned by Shopify. No fabricated collection handles.
    const vendors=[...new Set(rows.map(p=>p.vendor).filter(Boolean))];
    if(!i.brand)for(const vendor of vendors) {
      const pool=rows.filter(p=>p.vendor===vendor),type=pool.find(p=>p.type&&!genericType.test(p.type))?.type;
      if(!type||i.lineIntent&&!/^(rope|line|cordage)$|halyard line/.test(canonical(type)))continue;
      const vendorLabel=vendor.replace(/\b(Sailing Gear|Sailboat Hardware)\b/gi,'').trim().replace(i.lineIntent?/ Ropes$/i:/$^/,'').replace(/^sailing\b/i.test(subject)?/\s+sailing$/i:/$^/,'');
      const typeComponent=componentOf(type);
      const detail=i.lineIntent||i.component?.includes(' ')||i.component&&typeComponent&&typeComponent!==i.component?subject:/hardware|fitting|accessor|cleat|spare part/i.test(type)?type:subject||type;
      const label=[vendorLabel,boatOf(type)?.key===i.boat?.key?'':boatLabel,detail].filter(Boolean).join(' ');
      addSearch(label,[...typeScope(type),leaf('vendor',vendor)],pool,'brand',70,'refine');
    }
    // Left-column items are scoped search URLs. Collection navigation belongs
    // exclusively in the right column, rather than competing with brand refinements.
    const result=[],keys=new Set([labelKey(i.query),labelKey(i.raw)]),urls=new Set(),kinds=new Map(),support=new Set();
    candidates.sort((a,b)=>b.score-a.score);
    const hasRefinements=candidates.some(c=>c.group==='refine');
    for(const c of candidates) {
      if(hasRefinements&&c.group==='search'&&result.filter(r=>r.group==='search').length>=4)continue;
      const key=labelKey(c.label),u=new URL(c.url,origin);u.hash='';for(const k of [...u.searchParams.keys()])if(k.startsWith('_'))u.searchParams.delete(k);c.url=u.href;
      const kind=c.kind.split(':')[0],count=kinds.get(kind)||0,evidenceKey=c.evidence.slice().sort().join('|');
      if(!key||keys.has(key)||urls.has(c.url)||c.label.length>78||count>=(kind==='brand'?3:kind==='attribute'?3:kind==='collection'?2:kind==='type'?(!i.component&&i.boat?4:2):3))continue;
      // Identical groups with alternate wording add no useful choice. Keep independent brand facets.
      if(!['brand','application'].includes(kind)&&support.has(evidenceKey))continue;
      result.push(c);keys.add(key);urls.add(c.url);kinds.set(kind,count+1);if(!['brand','application'].includes(kind))support.add(evidenceKey);
      if(result.length===7)break;
    }
    return result;
  }
  return {config,norm,canonical,has,identifier,compactIdentifier,identifierMatch,strongPartial,parse,url,exactQuery,score,rank,compareScores,facts,familyOf,brandOf,componentOf,collections,suggestions,isLine,relevantProduct,constraintEvidence,accessoryFor};

});
